import { render, staticRenderFns } from "./FMToolbar.vue?vue&type=template&id=3120b26a&scoped=true"
import script from "./FMToolbar.vue?vue&type=script&lang=js"
export * from "./FMToolbar.vue?vue&type=script&lang=js"
import style0 from "./FMToolbar.vue?vue&type=style&index=0&id=3120b26a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3120b26a",
  null
  
)

export default component.exports